import React, { useEffect, useState } from 'react';
import './SpreadPage.css';

const SpreadPage = () => {
  const [games, setGames] = useState([]);
  const [week, setWeek] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const backendBase =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    (window.location.hostname === 'localhost'
      ? 'http://localhost:5001'
      : 'https://pickem-backend-2025.onrender.com');

  // +#, -#, or PK
  const fmtSpread = (val) => {
    if (val === null || val === undefined || val === '') return '';
    const n = Number(val);
    if (Number.isNaN(n)) return String(val);
    if (n === 0) return 'PK';
    return n > 0 ? `+${n}` : n.toString();
  };

  // "YYYY-MM-DD hh:mm AM/PM"  ->  "Thursday August 28 6:00 PM"
  const niceDateTime = (raw) => {
    if (!raw) return '-';
    const str = String(raw).trim();

    // pull date part
    const dateMatch = str.match(/^(\d{4}-\d{2}-\d{2})/);
    if (!dateMatch) return str;
    const iso = dateMatch[1];

    // format date part in a stable way
    const [y, m, d] = iso.split('-').map(Number);
    const dt = new Date(Date.UTC(y, m - 1, d));
    const dateText = dt
      .toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC',
      })
      .replace(',', '');

    // pull time part (e.g., "6:00 PM"); tolerate missing time
    let timeText = '';
    const timeMatch = str.match(/^\d{4}-\d{2}-\d{2}\s+(\d{1,2}:\d{2})\s*([AP]M)/i);
    if (timeMatch) {
      timeText = `${timeMatch[1]} ${timeMatch[2].toUpperCase()}`;
    }

    return timeText ? `${dateText} ${timeText}` : dateText;
  };

  useEffect(() => {
    fetch(`${backendBase}/data/current_week.json`, { cache: 'no-store' })
      .then((res) => {
        if (!res.ok) throw new Error('current_week.json not found');
        return res.json();
      })
      .then((data) => setWeek(data.currentWeek ?? data.week ?? 1))
      .catch(() => {
        setError('Failed to load current week.');
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!week) return;
    setLoading(true);
    setError('');
    fetch(`${backendBase}/data/games_week_${week}.json`, { cache: 'no-store' })
      .then((res) => {
        if (!res.ok) throw new Error('File not found');
        return res.json();
      })
      .then((data) => {
        setGames(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => {
        setGames([]);
        setError(`No spread data available for Week ${week}.`);
        setLoading(false);
      });
  }, [backendBase, week]);

  return (
    <div className="page-container">
      <h2>Game Schedule - Week {week ?? '?'}</h2>

      <div style={{ marginBottom: 12 }}>
        <button onClick={() => window.print()} style={{ marginRight: 10 }}>
          🖨️ Print This Page
        </button>
        <button onClick={() => window.print()}>📄 Export to PDF</button>
      </div>

      {loading && <p>Loading games…</p>}
      {!!error && <p style={{ color: 'crimson' }}>{error}</p>}

      {!loading && games.length > 0 && (
        <table className="spread-table">
          <thead>
            <tr>
              <th>Date &amp; Time</th>
              <th>Team 1 (Odds)</th>
              <th>Team 2 (Odds)</th>
            </tr>
          </thead>
          <tbody>
            {games.map((g, idx) => {
              const d = g.date || '-';
              const t1 = g.team1 || '-';
              const t2 = g.team2 || '-';
              const s1 = fmtSpread(g.spread1);
              const s2 = fmtSpread(g.spread2);

              return (
                <tr key={idx}>
                  <td>{niceDateTime(d)}</td>
                  <td>
                    {t1} {s1 && <span className="odds">({s1})</span>}
                  </td>
                  <td>
                    {t2} {s2 && <span className="odds">({s2})</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SpreadPage;

